import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable, inject } from '@angular/core';
import { SpxToasterAutoCloseSpeedEnum, spxToasterActions } from '@softpak/components/spx-toaster';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { loadingCheckLocation, textErrorNoResultsFound } from 'src/app/shared/_config/i18n/i18n-interface';

import { ApiCntMethod } from 'src/app/api/api-methods.cnt';
import { Observable } from 'rxjs';
import { SharedCheckLocationActions } from './shared-check-location.actions';
import { SharedCheckLocationI } from 'src/app/api/shared-check-location/shared-check-location.result.int';
import { SharedErrorObjectI } from 'src/app/shared/models/shared/shared-error-object.interface';
import { SharedGenericService } from 'src/app/shared/services/shared-generic.service';
import { SharedPageTypeEnum } from 'src/app/shared/navigation/page-type.enum';
import { TranslateService } from '@ngx-translate/core';
import { sharedContainerSingleActions } from '../shared-container-single';
import { spxSpinnerActions } from '@softpak/components/spx-spinner';

@Injectable()
export class SharedCheckLocationEffects {
    private readonly actions$ = inject(Actions);
    private readonly sharedGenericService = inject(SharedGenericService);
    private readonly translateService = inject(TranslateService);


    load$ = createEffect(() =>
        this.actions$.pipe(ofType(SharedCheckLocationActions.load),
            mergeMap((params) => this.sharedGenericService.invoke(ApiCntMethod.sharedCheckLocation, { ...params.query }).pipe(
                map((result: SharedCheckLocationI) =>
                    result?.seqNr ? SharedCheckLocationActions.received({
                        result,
                    }) : SharedCheckLocationActions.error({
                        error: this.translateService.instant(textErrorNoResultsFound),
                    })),
                catchError((error: SharedErrorObjectI) => [
                    SharedCheckLocationActions.error({
                        error: error.message,
                    }),
                ])
            ))
        ));

    onError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(SharedCheckLocationActions.error),
        mergeMap(action => [
            spxToasterActions.createError({
                autoClose: SpxToasterAutoCloseSpeedEnum.DEFAULT,
                messageText: action.error,
            }),
        ]))
    );

    afterLoad$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(SharedCheckLocationActions.load),
        mergeMap(() => [
            spxSpinnerActions.show({
                action: loadingCheckLocation
            }),
        ]))
    );

    afterError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(SharedCheckLocationActions.error),
        mergeMap(() => [
            spxSpinnerActions.hide({
                action: loadingCheckLocation
            }),
        ]))
    );

    afterReceived$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(SharedCheckLocationActions.received),
        mergeMap((action) => [
            sharedContainerSingleActions.load({
                data: {
                    seqNr: action.result.seqNr,
                },
                pageType: SharedPageTypeEnum.ordAutomaticShuffle,
            }),
            spxSpinnerActions.hide({
                action: loadingCheckLocation
            }),
        ]))
    );
}
